import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

const load = () =>
  JSON.parse(localStorage.getItem('sp_cart_state') || '{}');

const save = (state) =>
  localStorage.setItem('sp_cart_state', JSON.stringify(state));

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => ({
    id:   null,
    qty:  0,
    url:  null,
    lines: [],   // [{id,lineId,title,qty,price,image}]
    ...load(),
  }));

  const updateCart = (partial) => {
    const next = { ...cart, ...partial };
    setCart(next);
    save(next);
  };

  return (
    <CartContext.Provider value={{ ...cart, updateCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
